// extracted by mini-css-extract-plugin
export var divider = "_mh-0";
export var labelWrapper = "_mh-2";
export var lineSvg = "_mh-1";